import { render } from "./App.vue?vue&type=template&id=50fe0015"
const script = {}

import "./App.vue?vue&type=style&index=0&id=50fe0015&lang=css"

import exportComponent from "C:\\Users\\Midea\\Desktop\\产品管理系统\\ProductManager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__